import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../button/button';

import { featuredImage } from "../../utilities";

import './randomEmployee.css';
import anonymousPerson from './anonymous.png';
import get from 'lodash.get';



class RandomEmployee extends Component {

    componentWillMount() {
        this.randomEmployee = this.props.employees[Math.floor(Math.random() * this.props.employees.length)];
    }

    render() {

        let name = 'John Doe';
        let image = anonymousPerson;

        if (this.randomEmployee) {
            var randomEmployee = this.randomEmployee;
            let featuredImageUrl = featuredImage(randomEmployee, "medium_large");

            name = get(randomEmployee, 'employeedetails.0.roepnaam', 'John');

            if (featuredImageUrl) {
                image = featuredImageUrl;
            }
        }

        let personStyle = {
            backgroundImage: `url('${image}')`
        }

        return (
            <div className="randomEmployee">
                <div className="randomEmployee__contentWrapper" style={personStyle}>
                    <div className="randomEmployee__details">
                        <span className="randomEmployee__name" dangerouslySetInnerHTML={{__html: name}}/>
                    </div>
                    <Button name="De mensen van KWOOT" href="/de-mensen-van-kwoot"/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {
    let employees = {};

    if (store.employees && store.employees.employees) {
        employees = store.employees.employees;
    }

    return {
        employees: employees
    }
}

export default connect(mapStateToProps)(RandomEmployee);



// WEBPACK FOOTER //
// ./src/components/randomEmployee/randomEmployee.js